import { render } from "./TransactionHistory.vue?vue&type=template&id=51e1292a"
import script from "./TransactionHistory.vue?vue&type=script&lang=js"
export * from "./TransactionHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Customers/TransactionHistory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51e1292a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51e1292a', __exports__)) {
    api.reload('51e1292a', __exports__)
  }
  
  module.hot.accept("./TransactionHistory.vue?vue&type=template&id=51e1292a", () => {
    api.rerender('51e1292a', render)
  })

}


export default __exports__